import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  title: {
    margin: 0,
    marginBottom: 15,
    fontSize: 16,
    fontWeight: 600,
    color: theme.custom.darkBlue,
  },
  textWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    fontWeight: 600,
  },
  end: {
    justifyContent: 'flex-end',
  },
  text: {
    fontSize: 15,
    fontFamily: 'NeoSansStd',
    color: 'inherit',
  },
  amount: {
    fontSize: 17,
  },
  darkblue: {
    color: theme.custom.darkBlue,
  },
  green: {
    color: theme.custom.accept,
  },
  percent: {
    fontSize: 24,
    fontWeight: 400,
  },
  red: {
    color: theme.custom.warning,
  },
}));
